export const DATA_SCOPE_OWNER = 'Owner';

export enum tableName {
  Affiliation = 'Affiliation',
  Agency = 'Agency',
  Division = 'Division'
}
interface ReportSection {
  tableName: tableName;
  reportId: string;
  sectionId?: string;
}

type ColumnNamesTypes = {
  [K in tableName]: string;
};

export const ColumnNames: ColumnNamesTypes = {
  [tableName.Affiliation]: 'AffiliationOrganizationCode',
  [tableName.Agency]: 'organizationCode',
  [tableName.Division]: 'RootOrganizationCode'
};

interface SalesJournals {
  ctid: string;
  workspaceId: string;
  affiliation: ReportSection;
  agency: ReportSection;
  division: ReportSection;
}

interface ReportType {
  SalesJournals: SalesJournals;
  SalesActivity:SalesJournals
}


export interface SearchOrgPostData {
  code: string;
  category: string;
  includeChild?: any;
}
